import 'styles/controls/Separators.sass'

export function BlankSeparator() {
  return (
    <div className="blankSep"></div>
  )
}

export function LineSeparator() {
  return (
    <div className="lineSep"><hr/></div>
  )
}